module.exports = __webpack_public_path__ + "img/pix_icon.9efd0adc.svg";